/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MMEToolPalette from './MMEToolPalette';
import MMESmartSearchEditor from './MMESmartSearchEditor';
import MMEEditor from './MMEEditor';
import MMEViewer from './MMEViewer';

class MMELanding extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.mmeSmartSearchEditor = React.createRef();
  }


  handleMMEEdit = (idKey, dataSmartSearch, keyword) =>
    this.mmeSmartSearchEditor.current.handleMMEEdit(idKey, dataSmartSearch, keyword);

  render() {
    return (
      <div>
        <input
          type="checkbox"
          className="sidebar-left"
          id="sidebar-left-01"
          onChange={this.props.handlesideBarToggle}
          checked={this.props.sideBarChecked}
        />
        <label className="sidebar-left" htmlFor="sidebar-left-01" />
        <MMEToolPalette
          BasesDataGrid={this.props.gridData.BasesDataGrid}
          TargetsDataGrid={this.props.gridData.TargetsDataGrid}
          mmeStudy={this.props.mmeStudy}
          studies={this.props.studies}
          trackerFn={this.props.trackerFn}
          handleMMEEdit={this.handleMMEEdit}
          exportMMEReport={this.props.exportMMEReport}
          runMMEReport={this.props.runMMEReport}
          landingTarget={this.props.landingTarget}
        />
        <div className="width-80 portfolio-crosstab float-left portfolio-crosstab-height">
          <div className="crosstab-accordion">
            <MMESmartSearchEditor
              getSampleWeighted={this.props.getSampleWeighted}
              fetchKPI={this.props.fetchKPI}
              removeKPI={this.props.removeKPI}
              updateModuleStudy={this.props.updateModuleStudy}
              hideWeightType={this.props.hideWeightType}
              handleStudyChange={this.props.handleStudyChange}
              gridData={this.props.gridData}
              runMMEReport={this.props.runMMEReport}
              returnToEditor={this.props.returnToEditor}
              trackerFn={this.props.trackerFn}
              ref={this.mmeSmartSearchEditor}
              landingTarget={this.props.landingTarget}
              runReportAfterWeightChange={this.props.runReportAfterWeightChange}
            />
            {!this.props.isEnableMMEViewer && <div>
              <MMEEditor
                data-test="MMEEditorComp"
                handleSelect={this.props.handleSelect}
                mediaList={this.props.mediaList}
                selectedMediaVehicleIndex={this.props.selectedMediaVehicleIndex}
                statementList={this.props.statementList}
                updateSelectedAction={this.props.updateSelectedAction}
                selectedStatementVariables={this.props.statementVariableSelected}
                updateReportType={this.props.updateReportTypeAction}
                selectedReportType={this.props.selectedReportType}
                dimensionList={this.props.dimensionList}
                updateDimensionType={this.props.updateDimensionType}
                selectedDimensionType={this.props.selectedDimensionType}
                onChangeProperty={this.props.onChangeProperty}
                trackerFn={this.props.trackerFn}
                vehicleCodeCount={this.props.vehicleCodeCount}
              />
            </div>}
            {this.props.isEnableMMEViewer &&
              <div>
                <MMEViewer
                  data-test="MMEViewerComp"
                  returnToEditor={this.props.returnToEditor}
                  statementVariableLabel={this.props.statementVariableLabel}
                  mmeAllTargets={this.props.mmeAllTargets}
                  reportType={this.props.reportType}
                  trackerFn={this.props.trackerFn}
                  runMMEReport={this.props.runMMEReport}
                  landingIndex={this.props.landingIndex}
                />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

MMELanding.propTypes = {
  studies: PropTypes.instanceOf(Array),
  mmeStudy: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  getSampleWeighted: PropTypes.func.isRequired,
  fetchKPI: PropTypes.func.isRequired,
  gridData: PropTypes.instanceOf(Object).isRequired,
  handlesideBarToggle: PropTypes.func.isRequired,
  sideBarChecked: PropTypes.bool.isRequired,
  updateModuleStudy: PropTypes.func.isRequired,
  hideWeightType: PropTypes.bool.isRequired,
  handleStudyChange: PropTypes.func.isRequired,
  runMMEReport: PropTypes.func,
  exportMMEReport: PropTypes.func,
  isEnableMMEViewer: PropTypes.bool,
  onChangeProperty: PropTypes.func,
  updateDimensionType: PropTypes.func,
  returnToEditor: PropTypes.func,
  updateSelectedAction: PropTypes.func,
  handleSelect: PropTypes.func,
  mediaList: PropTypes.shape({}),
  statementList: PropTypes.shape({}),
  dimensionList: PropTypes.shape({}),
  updateReportTypeAction: PropTypes.func,
  selectedDimensionType: PropTypes.number,
  selectedReportType: PropTypes.string,
  statementVariableSelected: PropTypes.instanceOf(Array),
  selectedMediaVehicleIndex: PropTypes.number,
  statementVariableLabel: PropTypes.string,
  mmeAllTargets: PropTypes.instanceOf(Array),
  reportType: PropTypes.string,
  trackerFn: PropTypes.func,
  landingIndex: PropTypes.number,
  landingTarget: PropTypes.string,
  vehicleCodeCount: PropTypes.number,
  runReportAfterWeightChange: PropTypes.func,
  removeKPI: PropTypes.func,
};

MMELanding.defaultProps = {
};

export default MMELanding;
